import updateQueryParam from "@casino/client/utils/updateQueryParam/updateQueryParam";
import debounce from "@casino/shared/utils/debounce/debounce";
import { useRouter } from "next/navigation";
import { useCallback, useState } from "react";

type Props = {
  type: FilterSection;
  searchParams: Partial<Record<string, string>>;
};

const useSelectFilter = ({ type, searchParams }: Props) => {
  const router = useRouter();
  const defaultValue = searchParams[type]?.split(",") ?? [];
  const [selected, setSelected] = useState<string[]>(defaultValue);

  const updateURL = useCallback(
    debounce((newSelected: string[]) => {
      const href = window.location.href;
      const backToPageOne = updateQueryParam(href, "page");
      return router.push(
        updateQueryParam(backToPageOne, type, newSelected.join(",")),
      );
    }, 1000),
    [router, type],
  );

  const handleChange = (newSelected: string[]) => {
    setSelected(newSelected);
    updateURL(newSelected);
  };

  return {
    selected,
    handleChange,
  };
};

export default useSelectFilter;
